import { useMemo } from "react";
import useGetAllCircuitsQuery from "hooks/useGetAllCircuitsQuery";
import type { Circuit } from "types/circuit";

/**
 * Resolves a circuit by id from the org's circuits (shared SWR cache).
 * Mirrors {@link useExercise}, additionally exposing `isLoading` so consumers
 * can distinguish "still fetching" from "circuit deleted".
 */
function useCircuit(id: string | undefined | null): { circuit: Circuit | null; isLoading: boolean } {
  const { data: circuits, isLoading } = useGetAllCircuitsQuery();

  const circuit = useMemo(() => (id && circuits.find((entry) => entry.id === id)) || null, [circuits, id]);

  return useMemo(() => ({ circuit, isLoading }), [circuit, isLoading]);
}

export default useCircuit;
